import $ from 'jquery';
import {showFormResponse} from "../common/json-response";

export default function() {
  const deleteButtons = document.querySelectorAll('.delete_custom_work_columns');
  const statusWrapper = document.querySelector('.action-status-messages');

  const deleteHandler = function (e) {
    e.preventDefault();
    const button = e.currentTarget;
    const fieldUuid   = button.getAttribute('data-custom-field-uuid');
    const url = button.getAttribute('data-delete-url');

    const parentBlock = button.closest('.work-columns-row');
    const workColumns = parentBlock.querySelectorAll('.work-column-value');
    const workColumnsUuids = [];

    workColumns.forEach(function (workColumn) {
      workColumnsUuids.push(workColumn.getAttribute('data-work-column-uuid'));
    });

    const data = {
      fieldUuid,
      workColumnsUuids
    };

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      data: data,
      success: function (data) {
        if (data.redirectTo?.length) {
          window.location.href = data.redirectTo;
        }

        showFormResponse(data);

        if (data.status !== 'success') {
          return;
        }

        parentBlock.remove();
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          const statusMsg = document.createElement('div');
          statusMsg.classList.add(['alert']);
          statusMsg.classList.add(['alert_error']);
          statusMsg.innerHTML = message;
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  };

  deleteButtons?.forEach(function (button) {
    button.addEventListener('click', deleteHandler);
  });
}